import { render } from "./transfer.vue?vue&type=template&id=fffb412e"
import script from "./transfer.vue?vue&type=script&lang=js"
export * from "./transfer.vue?vue&type=script&lang=js"
script.render = render

export default script